import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useLanguage } from '../../../contexts/LanguageContext';

export const WarningMessage = () => {
  const { translations } = useLanguage();
  
  return (
    <div className="flex items-start gap-3 bg-yellow-50 text-yellow-700 p-4 rounded-lg">
      <AlertCircle className="shrink-0 mt-0.5" size={20} />
      <div className="text-sm">
        <p className="font-medium">
          {translations?.warningMessage?.title || 'تنبيه مهم'}
        </p>
        <p>
          {translations?.warningMessage?.message || 
            'تأكد من أن الملف يتبع النموذج المطلوب. يمكنك تحميل نموذج مثالي من زر "مثال للرفع".'}
        </p>
      </div>
    </div>
  );
};